export * from './InstantSearchPagination'
export type { IPaginationProps } from './InstantSearchPagination'

export * from './Pagination'
